import React from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Clock } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { IconBlob } from "@/components/IconBlob";
import { timeAgo, distanceLabel } from "@/lib/format";

const ASKED = { private: "Privato", company: "Azienda", entity: "Ente" };

export default function RequestCard({ req }) {
  const navigate = useNavigate();
  const { getCategory, catName } = useApp();
  const cat = getCategory(req.category);
  const isToday = req.when === "today";
  const sub = cat?.subcategories?.find((s) => s.slug === req.subcategory);
  const subLabel = req.other_description || (sub ? catName(sub) : "");

  return (
    <button
      data-testid="request-item-card"
      onClick={() => navigate(`/request/${req.id}`)}
      className="group text-left w-full bg-white rounded-[18px] p-4 flex gap-3"
    >
      <IconBlob icon={cat?.icon} seed={cat?.slug} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 mb-1 flex-wrap">
          {isToday && (
            <span data-testid="urgency-badge" className="rounded-full bg-[#E8590C] text-white px-2 py-0.5 text-[11px] font-semibold">
              Oggi
            </span>
          )}
          <span className="text-[11px] text-[#4A4E68] uppercase tracking-wide">{ASKED[req.asked_as] || ""}</span>
          <span className="text-[11px] text-[#141A3A] font-medium ml-auto">
            {req.is_online ? "Online" : distanceLabel(req.distance_km)}
          </span>
        </div>
        <h3 className="text-base font-semibold text-[#0F1230] leading-snug truncate">{req.title}</h3>
        {subLabel && <p className="text-sm text-[#4A4E68] truncate">{subLabel}</p>}
        <div className="flex items-center gap-3 mt-1.5 text-xs text-[#4A4E68]">
          {!req.is_online && req.city && (
            <span className="inline-flex items-center gap-1"><MapPin size={13} /> {req.city}</span>
          )}
          <span className="inline-flex items-center gap-1"><Clock size={13} /> {timeAgo(req.created_at)}</span>
          <span className="ml-auto font-medium text-[#141A3A]">
            {req.availability_count > 0
              ? `${req.availability_count}/${req.max_availabilities} disponibili`
              : "Sii il primo"}
          </span>
        </div>
      </div>
    </button>
  );
}
